/* ONNI · PDP-Bildergalerie am Desktop sticky (Johannes 21.10.2026, Ada)
   Die Galerie bleibt links stehen, rechts scrollt die Beschreibung durch.
   Ist die Galerie höher als das Fenster, scrollt sie erst mit, bis ihr unteres Ende
   sichtbar ist, und bleibt dann hängen. Dafür wird der Sticky-Abstand oben negativ:
   --onni-galerie-top = min(Abstand oben, Fensterhöhe - Galeriehöhe - Abstand unten).
   CSS dazu in base-overwrite.css. Läuft auch nach dem Linien-Wechsel (morph), weil die
   Galerie bei jedem Durchlauf neu gesucht wird. */
(() => {
  if (window.__onniGalerieSticky) return;
  window.__onniGalerieSticky = true;
  const ABSTAND = 24;
  const mq = matchMedia('(min-width: 750px)');
  let geplant = false;
  const setzen = () => {
    geplant = false;
    const g = document.querySelector('.product-information__media media-gallery');
    if (!g) return;
    if (!mq.matches) { g.style.removeProperty('--onni-galerie-top'); return; }
    // Unten Platz für die feste Warenkorb-Leiste lassen, die beim Scrollen einblendet
    const leiste = document.querySelector('.sticky-add-to-cart__bar');
    const unten = ABSTAND + (leiste ? leiste.offsetHeight + 12 : 0);
    const top = Math.min(ABSTAND, Math.round(innerHeight - g.offsetHeight - unten));
    const neu = top + 'px';
    if (g.style.getPropertyValue('--onni-galerie-top') !== neu) g.style.setProperty('--onni-galerie-top', neu);
  };
  const planen = () => { if (!geplant) { geplant = true; requestAnimationFrame(setzen); } };
  addEventListener('resize', planen, { passive: true });
  addEventListener('scroll', planen, { passive: true });
  addEventListener('load', planen);
  mq.addEventListener('change', planen);
  planen();
})();
